module.exports = __webpack_public_path__ + "static/landing-page-reduce-tax-4fd10ca94f33881f8f8d49cb54eacfd1.png";